export enum TypeNotification {
  SUCESSO,
  FALHA,
  ATENÇÃO,
}
